var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupandevent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "calendar(1) 1",
    clipPath: "url(#clip0_206_4146)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_206_4146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath1403"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1401",
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_206_4146)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1399"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1405"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1407",
    d: "M11.4141 2.57803H12.5859M7.19536 2.57803H8.36719M19.8516 2.57803H20.7188C22.2657 2.57803 23.5313 3.8437 23.5313 5.39053V20.7188C23.5313 22.2655 22.2656 23.5312 20.7188 23.5312H3.28125C1.73442 23.5312 0.46875 22.2656 0.46875 20.7188V5.39053C0.46875 3.84366 1.73437 2.57803 3.28125 2.57803H4.14844M15.6329 2.57803H16.8047",
    stroke: "#202842",
    strokeWidth: 1.1,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1409"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1411",
    d: "M15.6719 6.79678H3.28125C2.8987 6.79678 2.57812 7.11736 2.57812 7.49991V20.7188C2.57812 21.1013 2.89875 21.4219 3.28125 21.4219H20.7188C21.1013 21.4219 21.422 21.1012 21.422 20.7188V7.49991C21.422 7.11736 21.1014 6.79678 20.7188 6.79678H9.89067",
    stroke: "#202842",
    strokeWidth: 1.1,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1413"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1415",
    d: "M14.1094 0.468628C14.6895 0.468628 15.1641 0.943237 15.1641 1.52332V3.63269C15.1641 4.21277 14.6895 4.68738 14.1094 4.68738C13.5292 4.68738 13.0547 4.21277 13.0547 3.63269V1.52332C13.0547 0.943237 13.5292 0.468628 14.1094 0.468628Z",
    stroke: "#202842",
    strokeWidth: 1.1,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1417"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1419",
    d: "M9.89062 0.468628C10.4707 0.468628 10.9453 0.943237 10.9453 1.52332V3.63269C10.9453 4.21277 10.4707 4.68738 9.89062 4.68738C9.31055 4.68738 8.83594 4.21277 8.83594 3.63269V1.52332C8.83594 0.943237 9.31055 0.468628 9.89062 0.468628Z",
    stroke: "#202842",
    strokeWidth: 1.1,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1421"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1423",
    d: "M5.67188 0.468628C6.25195 0.468628 6.72656 0.943237 6.72656 1.52332V3.63269C6.72656 4.21277 6.25195 4.68738 5.67188 4.68738C5.0918 4.68738 4.61719 4.21277 4.61719 3.63269V1.52332C4.61719 0.943237 5.0918 0.468628 5.67188 0.468628Z",
    stroke: "#202842",
    strokeWidth: 1.1,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1425"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1427",
    d: "M18.3281 0.468628C18.9082 0.468628 19.3828 0.943237 19.3828 1.52332V3.63269C19.3828 4.21277 18.9082 4.68738 18.3281 4.68738C17.748 4.68738 17.2734 4.21277 17.2734 3.63269V1.52332C17.2734 0.943237 17.748 0.468628 18.3281 0.468628Z",
    stroke: "#202842",
    strokeWidth: 1.1,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1429"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1431",
    d: "M13.3837 12.5135L15.5969 12.9258C15.915 12.9845 16.0278 13.372 15.8105 13.5948L14.2816 15.1751L14.5736 17.4088C14.6159 17.7339 14.2707 17.9629 13.9893 17.8101L12.029 16.8516L9.99274 17.8205C9.70807 17.9554 9.38121 17.7192 9.42916 17.3987L9.73661 15.2266L8.18805 13.5917C7.96713 13.359 8.0989 12.9779 8.40794 12.9242L10.5753 12.5442L11.6515 10.5664C11.8043 10.2858 12.2073 10.2931 12.3534 10.5711L13.3837 12.5135Z",
    stroke: "#202842",
    strokeWidth: 1.1,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_206_4146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupandevent);
export default __webpack_public_path__ + "static/media/groupandevent.cdfff6b9fa2064d91035f9a201d93945.svg";
export { ForwardRef as ReactComponent };